// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2rBKd","bigColWidth":"Table_bigColWidth__2rFOP","biggerColWidth":"Table_biggerColWidth__3XRvi","row":"Table_row__2JjPz","col":"Table_col__3HuiO"};